var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorAmenity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.359,
    y: 17.756,
    width: 5.612,
    height: 12.616,
    transform: "translate(-11.477 7.942) rotate(-31.879)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.207,19.398h5.69c1.566,0,2.836-1.27,2.836-2.836h0c0-1.566-1.27-2.836-2.836-2.836h-9.132c-1.527,0-3.004.55-4.159,1.55l-4.211,3.644,4.289,7.258h11.502c2.749,0,5.386-1.092,7.33-3.036l7.201-7.201c1.108-1.108,1.108-2.903,0-4.011h0c-1.108-1.108-2.904-1.108-4.011,0l-6.857,6.857c-.392.392-.924.613-1.479.613"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorAmenity);
export default __webpack_public_path__ + "static/media/indoor-amenity.0b20c4f945ccb5b9bb240c80c83aed9a.svg";
export { ForwardRef as ReactComponent };